import React, { Component } from "react";
export default class Porfolio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "all",
    };
  }

  handleCategoryChange = (category) => {
    this.setState({ selectedCategory: category });
  };

  getFilteredPortfolio = () => {
    const { selectedCategory } = this.state;
    const { portfolio } = this.props.resumeData;

    if (selectedCategory === "all") return portfolio;
    return portfolio.filter((item) => item.category === selectedCategory);
  };

  render() {
    const filteredPortfolio = this.getFilteredPortfolio();
    const categories = [
      "all",
      "fullstack",
      "frontend",
      "backend",
      "ecommerce",
      "dashboard",
    ];
    return (
      <section id="portfolio" className="section-block">
        <div className="row portfolio">
          <div className="three columns header-col">
            <h1>
              <span>Projects</span>
            </h1>
          </div>
          <div className="twelve columns main-col" style={{ marginTop: "20px" }}>
            <div className="section-intro portfolio-intro">
              <p className="section-kicker">Selected Work</p>
              <h2>Real products delivered from concept to production</h2>
              <p className="section-subtitle">
                Product-focused builds across SaaS, finance, logistics, and AI-driven platforms.
              </p>
            </div>
            <div className="portfolio-tabs">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => this.handleCategoryChange(cat)}
                  className={
                    this.state.selectedCategory === cat ? "active-tab" : ""
                  }
                >
                  {cat.charAt(0).toUpperCase() + cat.slice(1)}
                </button>
              ))}
            </div>

            <div className="portfolio-grid">
              {filteredPortfolio.map((item) => (
                <article className="portfolio-card" key={item.name}>
                  <img
                    src={item.imgurl}
                    alt={item.name}
                    className="card-image"
                  />
                  <div className="card-content">
                    <div className="card-header">
                      <h5>{item.name}</h5>
                      <span className="project-category">{item.category}</span>
                    </div>
                    <p className="card-description">{item.description}</p>
                    <p className="project-outcome">
                      {item.outcome || "Outcome: shipped and optimized for real users with measurable performance and UX improvements."}
                    </p>
                    <div className="stack-tags">
                      {item.stacks?.map((tech) => (
                        <span className="stack-tag" key={tech}>
                          {tech}
                        </span>
                      ))}
                    </div>
                    <div className="card-actions">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="card-btn card-btn-primary"
                      >
                        View Live
                      </a>
                      <a
                        href={item.source || item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="card-btn card-btn-secondary"
                      >
                        {item.source ? "Source" : "Details"}
                      </a>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
